import moment from 'moment';
import React from 'react';
// Scope of the Research Notification
const TenStepTemplate = ({ values }) => {
  const {
    client_name,
    specific_topic,
    specific_field,
    conference_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    registration_link,
    paper_title,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Hello ${client_name},` : `Hello [Lead's Name],`}</p>

      <p>
        Your research on {specific_topic ? specific_topic : `[specific topic]`}{' '}
        is highly relevant to addressing key challenges in{' '}
        {specific_field ? specific_field : `[specific field]`}, making it a
        perfect fit for{' '}
        <strong>
          {conference_name ? conference_name : `[Conference Name]`}
        </strong>
        , a CPD-accredited event scheduled for{' '}
        <strong>
          {conference_from_date && conference_to_date
            ? `${conference_from_date} - ${conference_to_date}`
            : `[Conference from and to Date]`}
        </strong>{' '}
        at{' '}
        <strong>
          {conference_location ? conference_location : `[Conference Location]`}
        </strong>
        .
      </p>

      <p>
        By presenting your paper, “
        <strong>{paper_title ? paper_title : `[Paper Title]`}</strong>
        ,” you’ll contribute innovative solutions that can impact academia,
        industry, and society. This is an excellent opportunity to:
      </p>

      <p>
        ✅ Gain global recognition <br />
        ✅ Publish in Scopus-indexed journals <br />✅ Earn a CPD certification
      </p>

      <p>
        Don’t miss this chance to showcase your work to a global audience of
        experts and peers.
      </p>

      <p>
        {registration_link ? (
          <>
            👉 Register Here:{' '}
            <a
              href={registration_link}
              target="_blank"
              // rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : (
          '👉 Register Here: [Registration Link]'
        )}
      </p>
      <p>
        If you have any questions or need assistance, feel free to reach out.
        Looking forward to seeing you at the conference!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TenStepTemplate;
